import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { Shitae } from '../../item';

/**
 * 下絵編集ダイアログ（移動、回転、拡縮）
 */
class ShitaeControllerDialog extends Dialog {
    MOVE_UNIT_1: number = 1;

    MOVE_UNIT_2: number = 2;

    MOVE_UNIT_3: number = 4;

    MOVE_UNIT_4: number = 10;

    ROTATE_UNIT_1: number = 1;

    ROTATE_UNIT_2: number = 2;

    ROTATE_UNIT_3: number = 4;

    ROTATE_UNIT_4: number = 10;

    SCALE_UNIT_1: number = 0.005;

    SCALE_UNIT_2: number = 0.01;

    SCALE_UNIT_3: number = 0.025;

    SCALE_UNIT_4: number = 0.05;

    TIME_PASSED_UNIT: number = 50;

    targetItem: marietta.webcad.item.Shitae;

    targetLayer: marietta.webcad.layer.ShitaeLayer;

    rotateTimer: any;

    timeoutId: any;

    timePassed: number;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      this.init();
    }

    /**
     * 初期設定
     */
    init() {
      // モーダルカラーを薄くする
      document.getElementById('modalBg').style.backgroundColor = '#000';
      document.getElementById('modalBg').style.opacity = '0.2';

      // 対象の下絵を登録
      const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
      this.targetLayer = (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(currentFloor, true) as marietta.webcad.layer.FloorShitaeLayer).layer_shitae;
      // eslint-disable-next-line prefer-destructuring
      this.targetItem = this.targetLayer.childList[0] as Shitae;

      // 下絵の状態を保持（リセット用）
      this.targetLayer.defaultScale = this.targetItem.spt.scaleX;
      this.targetLayer.defaultItemInfo = Object.assign(this.targetLayer.defaultItemInfo, this.targetItem.itemInfo);

      const id = 'dialogShitaeController';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Edit Picture Size And Position'; break;
        default: title = '下絵の位置と大きさの設定'; break;
      }

      let contents = '';
      contents += '<div class="controllerLeft">\n';
      contents += '<p class="controllerSubttl"><span class="jp">位置移動</span><span class="en">Move</span></p>\n';
      contents += '<div class="btnMoveWrap">\n';
      contents += '<button id="shitaeMoveUp" class="btnShitaeTransform btnUp">↑</button>\n';
      contents += '<button id="shitaeMoveDown" class="btnShitaeTransform btnDown">↓</button>\n';
      contents += '<button id="shitaeMoveLeft" class="btnShitaeTransform btnLeft">←</button>\n';
      contents += '<button id="shitaeMoveRight" class="btnShitaeTransform btnRight">→</button>\n';
      contents += '<div id="shitaeMoveCenter" class="capCenter"></div>\n';
      contents += '</div>\n';
      contents += '</div>\n';
      contents += '<div class="controllerRight secondView">\n';
      contents += '<p class="controllerSubttl"><span class="jp">編集</span><span class="en">Edit</span></p>\n';
      contents += '<table>\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<td><button id="shitaeRotateLeft" class="btnShitaeTransform btnRotateL"></button><p class="btnName"><span class="jp">左回転</span><span class="en">Rotate L</span></p></td>\n';
      contents += '<td><button id="shitaeRotateRight" class="btnShitaeTransform btnRotateR"></button><p class="btnName"><span class="jp">右回転</span><span class="en">Rotate R</span></p></td>\n';
      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<td><button id="shitaeScaleUp" class="btnShitaeTransform btnScaleUp"></button><p class="btnName"><span class="jp">拡大</span><span class="en">Zoom Up</span></p></td>\n';
      contents += '<td><button id="shitaeScaleDown" class="btnShitaeTransform btnScaleDown"></button><p class="btnName"><span class="jp">縮小</span><span class="en">Zoom Down</span></p></td>\n';
      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<td><button id="shitaeTransformReset" class="btnReset"></button><p class="btnName"><span class="jp">リセット</span><span class="en">Reset Changes</span></p></td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>\n';

      const footer = '<button id="shitaeTransformConfirm">OK</button>';

      this.createDialog(id, title, contents, footer);

      // アクション
      const self = this;
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;

      if (ua.isMobile || ua.isTablet) {
        document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
          // preventDefault を効かせるため passive:false で登録（iOSの長押しコールアウト/スクロール抑止）
          element.addEventListener('touchstart', self.onMouseDownTransform, { passive: false });
        });
      } else {
        document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
          element.addEventListener('mousedown', self.onMouseDownTransform);
        });
      }
      document.getElementById('shitaeTransformReset').addEventListener('click', self.controlHandlerTransformReset);
      document.getElementById('shitaeTransformConfirm').addEventListener('click', self.controlHandlerTransformConfirm);
      ua = null;

      // キャプチャのサムネイル読み込み
      const { imgSrc } = this.targetLayer;
      this.loadThumbnail(imgSrc);
    }

    /**
     * 変形ボタンが押された
     */
    onMouseDownTransform = (e) => {
      // 時間の経過のリセット
      this.timePassed = 0;

      const self = this;
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        // iOSの長押しコールアウト/スクロールを抑止
        if (e.cancelable) e.preventDefault();
        document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
          element.addEventListener('touchend', self.onMouseUpTransform);
          // touchcancel でも確実に停止する。未処理だと指を離しても連続変形が止まらない
          element.addEventListener('touchcancel', self.onMouseUpTransform);
        });
      } else {
        document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
          element.addEventListener('mouseup', self.onMouseUpTransform);
        });
        document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
          element.addEventListener('mouseout', self.onMouseUpTransform);
        });
      }
      ua = null;

      const targetBtnId: string = e.currentTarget.getAttribute('id');
      switch (targetBtnId) {
        case 'shitaeMoveUp':
          this.moveY(false);
          break;
        case 'shitaeMoveDown':
          this.moveY(true);
          break;
        case 'shitaeMoveLeft':
          this.moveX(false);
          break;
        case 'shitaeMoveRight':
          this.moveX(true);
          break;
        case 'shitaeRotateLeft':
          this.rotate(false);
          break;
        case 'shitaeRotateRight':
          this.rotate(true);
          break;
        case 'shitaeScaleUp':
          this.scale(true);
          break;
        case 'shitaeScaleDown':
          this.scale(false);
          break;
        default: return;
      }

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.rotateTimer = setInterval(() => {
          switch (targetBtnId) {
            case 'shitaeMoveUp':
              this.moveY(false);
              break;
            case 'shitaeMoveDown':
              this.moveY(true);
              break;
            case 'shitaeMoveLeft':
              this.moveX(false);
              break;
            case 'shitaeMoveRight':
              this.moveX(true);
              break;
            case 'shitaeRotateLeft':
              this.rotate(false);
              break;
            case 'shitaeRotateRight':
              this.rotate(true);
              break;
            case 'shitaeScaleUp':

              this.scale(true);
              break;
            case 'shitaeScaleDown':
              this.scale(false);
              break;
            default:
          }
        }, 50);
      }, 200);
    }

    /**
     * マウスがUPされた
     */
    onMouseUpTransform = () => {
      const self = this;
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
          element.removeEventListener('touchend', self.onMouseUpTransform);
          element.removeEventListener('touchcancel', self.onMouseUpTransform);
        });
      } else {
        document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
          element.removeEventListener('mouseup', self.onMouseUpTransform);
        });
      }
      ua = null;

      clearTimeout(this.timeoutId);
      clearInterval(this.rotateTimer);
    }

    /**
    * 移動ボタンが押された
    * @param true = down, false = up;
    */
    moveY(down: boolean) {
      this.timePassed += this.TIME_PASSED_UNIT;
      let sokudo: number = this.MOVE_UNIT_1;
      let param: number;

      // 時間と共に回転を早くする
      if (this.timePassed > 3000) {
        sokudo = this.MOVE_UNIT_4;
      } else if (this.timePassed > 1000) {
        sokudo = this.MOVE_UNIT_3;
      } else if (this.timePassed > 500) {
        sokudo = this.MOVE_UNIT_2;
      }

      if (down) {
        param = this.targetItem.itemInfo.y + sokudo;
      } else {
        param = this.targetItem.itemInfo.y - sokudo;
      }
      this.targetItem.moveY(param);
    }

    /**
    * 移動ボタンが押された
    * @param true = right, false = left;
    */
    moveX(right: boolean) {
      this.timePassed += this.TIME_PASSED_UNIT;
      let sokudo: number = this.MOVE_UNIT_1;
      let param: number;

      // 時間と共に回転を早くする
      if (this.timePassed > 3000) {
        sokudo = this.MOVE_UNIT_4;
      } else if (this.timePassed > 1000) {
        sokudo = this.MOVE_UNIT_3;
      } else if (this.timePassed > 500) {
        sokudo = this.MOVE_UNIT_2;
      }

      if (right) {
        param = this.targetItem.itemInfo.x + sokudo;
      } else {
        param = this.targetItem.itemInfo.x - sokudo;
      }
      this.targetItem.moveX(param);
    }

    /**
    * 回転ボタンが押された
    * @param true = 時計回り, false = 反時計回り;
    */
    rotate(clockwise: boolean) {
      this.timePassed += this.TIME_PASSED_UNIT;
      let sokudo: number = this.ROTATE_UNIT_1;
      let param: number;

      // 時間と共に回転を早くする
      if (this.timePassed > 3000) {
        sokudo = this.ROTATE_UNIT_4;
      } else if (this.timePassed > 1000) {
        sokudo = this.ROTATE_UNIT_3;
      } else if (this.timePassed > 500) {
        sokudo = this.ROTATE_UNIT_2;
      }

      if (clockwise) {
        param = this.targetItem.itemInfo.rotation + sokudo;
      } else {
        param = this.targetItem.itemInfo.rotation - sokudo;
      }
      this.targetItem.rotate(param);
    }

    /**
    * 拡大縮小ボタンが押された
    * @param true = 拡大, false = 縮小;
    */
    scale(expansion: boolean) {
      this.timePassed += this.TIME_PASSED_UNIT;
      let sokudo: number = this.SCALE_UNIT_1;
      let param: number;

      // 時間と共に回転を早くする
      if (this.timePassed > 3000) {
        sokudo = this.SCALE_UNIT_4;
      } else if (this.timePassed > 1000) {
        sokudo = this.SCALE_UNIT_3;
      } else if (this.timePassed > 500) {
        sokudo = this.SCALE_UNIT_2;
      }

      if (expansion) {
        param = this.targetItem.spt.scaleX + sokudo;
      } else {
        param = this.targetItem.spt.scaleX - sokudo;
        if (param <= 0) return;
      }
      this.targetItem.spt.scaleX = param;
      this.targetItem.spt.scaleY = param;
      this.targetItem.spt.update();
    }

    /**
    * リセットボタンが押された
    */
    controlHandlerTransformReset = () => {
      this.targetLayer.resetImage();
    }

    /**
    * OKボタンが押された
    */
    controlHandlerTransformConfirm = () => {
      // 連続変形タイマーが残っていたら停止（取りこぼし防止）
      clearTimeout(this.timeoutId);
      clearInterval(this.rotateTimer);
      // FloorLayerのすべてのレイヤーを表示
      this.targetLayer.showHideAllFloorLayers(true);
      marietta.webcad.WebCADGlobal.removeDialog();
    }

    /**
     * サムネイルの読み込み
     */
    // eslint-disable-next-line class-methods-use-this
    loadThumbnail(src: string) {
      const src1 = `url(${src})`;
      document.getElementById('shitaeMoveCenter').style.backgroundImage = src1;
    }

    /**
     * 閉じるボタンが押された
     */
    close = () => {
      // 連続変形タイマーが残っていたら停止（取りこぼし防止）
      clearTimeout(this.timeoutId);
      clearInterval(this.rotateTimer);
      // FloorLayerのすべてのレイヤーを表示
      this.targetLayer.showHideAllFloorLayers(true);
      this.targetLayer.resetImage();
      this.closeEvent();
    }
}

export default ShitaeControllerDialog;
